import React from 'react';

const SIZE = 13;

const IconText = () => (
    <svg width={SIZE} height={SIZE} viewBox="0 0 24 24" fill="none" aria-hidden>
        <path
            d="M4 7h16M4 12h10M4 17h14"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
        />
    </svg>
);

const IconImage = () => (
    <svg width={SIZE} height={SIZE} viewBox="0 0 24 24" fill="none" aria-hidden>
        <rect x="3" y="5" width="18" height="14" rx="2" stroke="currentColor" strokeWidth="2" />
        <circle cx="8.5" cy="10" r="1.5" fill="currentColor" />
        <path
            d="M21 16l-5-5-7 7"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
);

const IconFile = () => (
    <svg width={SIZE} height={SIZE} viewBox="0 0 24 24" fill="none" aria-hidden>
        <path
            d="M14 3H7a2 2 0 00-2 2v14a2 2 0 002 2h10a2 2 0 002-2V8l-5-5z"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinejoin="round"
        />
        <path d="M14 3v5h5" stroke="currentColor" strokeWidth="2" strokeLinejoin="round" />
    </svg>
);

const IconAudio = () => (
    <svg width={SIZE} height={SIZE} viewBox="0 0 24 24" fill="none" aria-hidden>
        <path
            d="M9 18V6l10-2v12"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <circle cx="7" cy="18" r="2.5" stroke="currentColor" strokeWidth="2" />
        <circle cx="17" cy="16" r="2.5" stroke="currentColor" strokeWidth="2" />
    </svg>
);

const IconVideo = () => (
    <svg width={SIZE} height={SIZE} viewBox="0 0 24 24" fill="none" aria-hidden>
        <rect x="3" y="6" width="13" height="12" rx="2" stroke="currentColor" strokeWidth="2" />
        <path
            d="M16 10l5-3v10l-5-3V10z"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinejoin="round"
        />
    </svg>
);

export const MODALITY_META = {
    text: { label: 'Текст', Icon: IconText },
    image: { label: 'Изображение', Icon: IconImage },
    file: { label: 'Файл', Icon: IconFile },
    audio: { label: 'Аудио', Icon: IconAudio },
    video: { label: 'Видео', Icon: IconVideo },
};

export const MODALITY_ORDER = ['text', 'image', 'file', 'audio', 'video'];

function normalizeList(list) {
    const set = new Set((list || []).map((m) => String(m).toLowerCase()));
    return MODALITY_ORDER.filter((key) => set.has(key));
}

function ModalityChip({ modality, kind, isDark = false }) {
    const meta = MODALITY_META[modality];
    if (!meta) return null;
    const { Icon, label } = meta;
    const title = kind === 'in' ? `Вход: ${label}` : `Выход: ${label}`;
    const tone =
        kind === 'in'
            ? isDark
                ? 'bg-sky-500/20 text-sky-300'
                : 'bg-sky-500/15 text-sky-600'
            : isDark
              ? 'bg-violet-500/20 text-violet-300'
              : 'bg-violet-500/15 text-violet-600';
    return (
        <span
            title={title}
            aria-label={title}
            className={`inline-flex h-[18px] w-[18px] shrink-0 items-center justify-center rounded ${tone}`}
        >
            <Icon />
        </span>
    );
}

/**
 * Иконки input_modalities / output_modalities из /api/models.
 * Голубые — вход, фиолетовые — выход.
 */
export default function ModelModalityIcons({
    inputModalities = [],
    outputModalities = [],
    className = '',
    isDark = false,
}) {
    const inputs = normalizeList(inputModalities);
    const outputs = normalizeList(outputModalities);
    if (!inputs.length && !outputs.length) return null;

    return (
        <div
            className={`flex shrink-0 flex-nowrap items-center gap-0.5 ${className}`}
            onClick={(e) => e.stopPropagation()}
            onMouseDown={(e) => e.stopPropagation()}
        >
            {inputs.map((m) => (
                <ModalityChip key={`in-${m}`} modality={m} kind="in" isDark={isDark} />
            ))}
            {inputs.length > 0 && outputs.length > 0 && (
                <span
                    className={`mx-0.5 text-[10px] ${isDark ? 'text-white/45' : 'opacity-35'}`}
                    aria-hidden
                >
                    →
                </span>
            )}
            {outputs.map((m) => (
                <ModalityChip key={`out-${m}`} modality={m} kind="out" isDark={isDark} />
            ))}
        </div>
    );
}
